/**
 * Giver status: LOADING, LOCKED, PENDING, CLAIMABLE, EXPIRED, UNAVAILABLE
 * Taker status: LOADING, CLAIMABLE, EXPIRED, UNAVAILABLE
 */
export enum MegaShareState {
  // API Fetching State
  LOADING = "loading",
  // Giver POV: Giver didn't share yet
  LOCKED = "locked",
  // Giver POV: Giver shared, waiting for taker to claim
  PENDING = "pending",
  // Taker POV: Giver shared, waiting for taker to claim
  // Giver POV: Taker claimed, can claim bonus
  CLAIMABLE = "claimable",
  // Both POV: Bonus expired
  EXPIRED = "expired",
  // Giver POV: Available = false
  // Taker POV: Available = false or Giver didn't share yet
  UNAVAILABLE = "unavailable",
}

export enum MegaShareActor {
  SHARER = "sharer",
  FRIEND = "friend",
}

export enum MegaShareFormTargetType {
  PHONE_NUMBER = "phone",
  EMAIL = "email",
  USERNAME = "username",
}

export const MegaSharePageParams = {
  DISPLAY_MODE: "m",
} as const;
